var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-block-title flex ai-c jc-sb"},[_c('div',{staticClass:"com-block-title-title"},[_vm._v(_vm._s(_vm.option.title))]),(_vm.option.more)?_c('div',{staticClass:"com-block-title-more flex ai-c jc-fe",on:{"click":_vm.toRank}},[_vm._v(" 更多"),_c('span')]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }